import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import useForm from 'shared/hooks/useForm';
import { Checkbox, ButtonsRow } from 'shared/components/Form';
import CloseButton from 'shared/components/buttons/Close/Close';
import styles from './CookieConsent.module.scss';

const CookieSettings = ({ onCloseSettings, onSubmit }) => {
  const { t } = useTranslation('common');

  const { values, handleChange, handleSubmit } = useForm(onSubmit, {
    analytics: false,
    marketing: false
  });

  return (
    <div className={styles.settingsWrapper}>
      <div className="row">
        <div className={`col-12 ${styles.settingsTitle}`}>
          <h2>{t('cookies.settingsTitle')}</h2>
          <CloseButton onClick={onCloseSettings}>{t('linkButton.close')}</CloseButton>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <p className={styles.question}>{t('cookies.settingsQuestion')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Checkbox
            disabled
            checked
            label={t('cookies.functionalTitle')}
            className={styles.chb}
          />
          <p>{t('cookies.functionalInfo')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Checkbox
            name="analytics"
            value={values.analytics}
            label={t('cookies.analyticsTitle')}
            onChange={handleChange}
            className={styles.chb}
          />
          <p>{t('cookies.analyticsInfo')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Checkbox
            name="marketing"
            value={values.marketing}
            label={t('cookies.marketingTitle')}
            onChange={handleChange}
            className={styles.chb}
          />
          <p>{t('cookies.marketingInfo')}</p>
        </div>
      </div>
      {/*
      <div className="row">
        <div className="col-12">
          <a href="">{t('cookies.moreInfoLink')}</a>
        </div>
      </div>
      */}
      <ButtonsRow
        className={styles.buttonsRow}
        submitTitle={t('cookies.savePreferences')}
        cancelTitle={t('linkButton.close')}
        onSubmit={handleSubmit}
        onCancel={onCloseSettings}
      />
    </div>
  );
};

CookieSettings.propTypes = {
  onCloseSettings: PropTypes.func,
  onSubmit: PropTypes.func,
};

CookieSettings.defaultProps = {
  onCloseSettings() {},
  onSubmit() {},
};

export default CookieSettings;
